import {Controller} from '@hotwired/stimulus';
import {useDebounce, useClickOutside, useTransition} from 'stimulus-use';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['dropdown'];

    static debounces = ['toggle'];

    static values = {
        dispatch: {
            type: Boolean,
            default: true,
        },
    };

    connect() {
        useDebounce(this, {wait: 100});
        useClickOutside(this);
        useTransition(this, {
            element: this.dropdownTarget,
            // enterActive: 'transition ease-out duration-300',
            // enterFrom: 'transform opacity-0',
            // enterTo: 'transform opacity-100',
            leaveActive: 'transition ease-in duration-100',
            leaveFrom: 'transform opacity-100',
            leaveTo: 'transform opacity-0',
        });
    }

    clickOutside() {
        if (!this.dropdownTarget.classList.contains('transform') && !this.dropdownTarget.classList.contains('hidden')) {
            this.close();
        }
    }

    open() {
        if (typeof window.openedDropdown !== 'undefined') {
            const ct = this.application.getControllerForElementAndIdentifier(window.openedDropdown, 'dropdown');
            if (ct) {
                ct.close();
            }
        }
        window.openedDropdown = this.element;

        if (this.button) {
            this.button.setAttribute('aria-expanded', 'true');
        }
        if (this.dispatchValue) {
            this.dispatch('dropdownOpen');
        }
        this.enter();
    }

    close() {
        if (this.button) {
            this.button.setAttribute('aria-expanded', 'false');
        }
        this.leave();
    }

    toggle() {
        if (this.transitioned) {
            this.close();
        } else {
            this.open();
        }
    }

    pickLang(e) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.params.lang !== 'undefined') {
            window.changeLanguage(e.params.lang);
        }
    }

    get button() {
        return this.element.querySelector('button');
    }
}
